import React from 'react';
import PropTypes from 'prop-types';
import isUndefined from 'lodash/isUndefined';
import { get, post } from '../../shared/utils/http';
import { buildSpectateUrl } from '../Utils/Spectate';
import { htmlToReact } from '../Utils/HtmlToReact';

class HtmlFromPhp extends React.Component {
    static propTypes = {
        url: PropTypes.string.isRequired,
        method: PropTypes.string,
        params: PropTypes.object,
        mode: PropTypes.oneOf([
            'cors',
            'no-cors',
            'same-origin',
            'navigate',
        ]),
        onComplete: PropTypes.func,
        onDomReady: PropTypes.func,
        onErrorShow: PropTypes.node,
    };

    static defaultProps = {
        method: 'GET',
        params: {},
        mode: 'cors',
    };

    constructor() {
        super();

        this.state = {
            html: '',
            errorComponent: null,
        };

        this.domNodeRef = React.createRef();
    }

    async componentDidMount() {
        let response;
        const url = buildSpectateUrl(this.props.url);
        const fetchParams = {
            mode: this.props.mode,
        };

        switch (this.props.method.toUpperCase()) {
            case 'POST':
                response = await post(url, this.props.params, fetchParams);

                break;
            case 'GET':
            default:
                response = await get(url, fetchParams);
        }

        if (response.ok) {
            const html = await response.text();

            /**
             * Use onComplete to load assets before
             * the DOM is rendered.
             */
            if (!isUndefined(this.props.onComplete)) {
                await this.props.onComplete();
            }

            this.setState({
                html,
            }, () => {
                /**
                 * Use onDomReady to load assets after
                 * the DOM is ready.
                 */
                if (!isUndefined(this.props.onDomReady)) {
                    this.props.onDomReady(this.domNodeRef.current);
                }
            });
        } else {
            /**
             * On Error mount this component instead
             */
            if (!isUndefined(this.props.onErrorShow)) {
                this.setState({
                    html: null,
                    errorComponent: this.props.onErrorShow,
                });
            }
        }
    }

    render() {

        let content = null;

        if (this.state.html) {
            content = htmlToReact(this.state.html);
        } else if (this.state.errorComponent) {
            content = this.state.errorComponent;
        }

        return (
            <div ref={this.domNodeRef}>{content}</div>
        );
    }
}

export default HtmlFromPhp;
